import React from 'react';
import { ArrowSmDownIcon, ArrowSmUpIcon } from '@heroicons/react/solid';
import clsx from 'clsx';

// Optimized Stats component with memoization
const Stats = React.memo(({ item, isLoading = false }) => {
	return (
		<div className="overflow-hidden rounded-lg bg-white px-4 py-5 sm:p-4 border border-blue-600 border-l-4">
			<dt className="truncate text-sm font-medium text-gray-900">
				{item.name}
			</dt>
			{isLoading ? (
				<div className="flex flex-row gap-4 h-8 items-center mt-1">
					<div className="h-3 w-3 bg-gray-200 rounded-full animate-ping" />
					<div className="h-3 w-3 bg-gray-200 rounded-full animate-ping" />
					<div className="h-3 w-3 bg-gray-200 rounded-full animate-ping" />
				</div>
			) : (
				<dd className="mt-1 text-xl font-semibold tracking-tight text-gray-900 flex items-baseline h-8">
					{item.stat}
					{item.changeType && (
						<span
							className={clsx(
								'ml-2 flex items-baseline text-sm font-semibold',
								item.changeType === 'increase'
									? 'text-green-600'
									: 'text-red-600'
							)}
						>
							{item.changeType === 'increase' ? (
								<ArrowSmUpIcon
									className="h-5 w-5 flex-shrink-0 self-center text-green-500"
									aria-hidden="true"
								/>
							) : (
								<ArrowSmDownIcon
									className="h-5 w-5 flex-shrink-0 self-center text-red-500"
									aria-hidden="true"
								/>
							)}
							<span className="sr-only">
								{item.changeType === 'increase' ? 'Increased' : 'Decreased'} by{' '}
							</span>
							{item.change}
						</span>
					)}
				</dd>
			)}
		</div>
	);
});

Stats.displayName = 'Stats';

export default Stats; 